import React from 'react'
import Img1 from '../assets/new-images/success_page_img.png';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
function Enquirysuccesspage() {

    const navigate = useNavigate();

    useEffect(() => {
        const timer = setTimeout(() => {
            navigate('/');
        }, 10000); // 10 seconds

        return () => clearTimeout(timer); // cleanup on unmount
    }, []);

    return (
        <section className='success_page pt-5 pb-5'>
            <div className='container'>
                <div className='row' style={{ justifyContent: 'center' }}>
                    <div className='col-8'>
                        <div className='inner-box'>
                            <div className='img_box text-center'>
                                <img src={Img1} alt='img' />
                            </div>
                            <p className='text-center mt-2'>Enquiry Submitted Successfully</p>
                            <div className='text-center mt-2'>
                                <Link to='/' className='btn btn-cart2'>Go to Home Page</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Enquirysuccesspage
